import {
  faPuzzlePiece,
  faRulerHorizontal,
  faStopwatch,
  faVial,
  faWeightScale,
} from "@fortawesome/free-solid-svg-icons";
import "./measure.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  useArticle,
  useActionsArticle,
} from "../../../../../context/inventory/ArticleFormProvider";
const Measure = () => {
  const { article } = useArticle();
  const actions = useActionsArticle();
  const { measures: elements, itemsCheckMeasure: checks, type } = article;
  const typesItems = [
    { name: "Unidad", type: "00", icon: faPuzzlePiece },
    { name: "Longitud", type: "01", icon: faRulerHorizontal },
    { name: "Volumen", type: "02", icon: faVial },
    { name: "Masa", type: "03", icon: faWeightScale },
    { name: "Presión", type: "04", icon: faStopwatch },
  ];
const getElementsFilter=(type)=>{
  return elements.elements.filter((m) => m.type === type);
}
  return (
    <section>
      <div
        style={{
          justifyContent: "space-around",
          marginBottom: "50px",
          height: "500px",
          overflowY: "auto",
        }}
        className="flex"
      >
        {typesItems.map((t, index) => {
          return (
            <div key={index} className="general-container-measure">
              <div className="flex justify-center">
                <div
                  onClick={() =>
                    t.type !== type && actions.changeTypeMeasureArticle(t.type)
                  }
                  className={`flex  btn-measure-default
                      ${
                        type === t.type
                          ? "btn-active-measure"
                          : "btn-inactive-measure"
                      }`}
                >
                  <div className="">
                    <FontAwesomeIcon icon={t.icon} /> &nbsp;
                    <label className="font1">{t.name}</label>
                  </div>
                </div>
              </div>
              {type === t.type && (
                <table className="table table-default-app">
                  <thead className="thead-measure thead-dark">
                    <tr className="header-table-measure txt-center">
                      <td>ID</td>
                      <td>Nombre</td>
                    </tr>
                  </thead>
                  <tbody>
                    {getElementsFilter(t.type).map((m,index) => {
                        return (
                          <tr key={m.id}>
                            <td
                              style={{
                                backgroundColor:
                                  checks.elements.includes(m.id) && "#dfeaf1",
                              }}
                              className="txt-center"
                            >
                              {m.id}
                            </td>
                            <td
                            id={`${getElementsFilter(t.type).length ===(index+1)&&"last-td-measure"}`}
                              style={{
                                backgroundColor:
                                  checks.elements.includes(m.id) && "#dfeaf1",
                              }}
                            >
                              {m.name} - {m.abreviature}
                            </td>
                            <th>
                              <input
                                className="lg-checkbox"
                                type="checkbox"
                                onChange={(e) => actions.checkMeasure(e, m.id)}
                                checked={checks.elements.includes(m.id)}
                              />
                            </th>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Measure;
